import { render, staticRenderFns } from "./userNews.vue?vue&type=template&id=6817c01c&scoped=true"
import script from "./userNews.vue?vue&type=script&lang=js"
export * from "./userNews.vue?vue&type=script&lang=js"
import style0 from "./userNews.vue?vue&type=style&index=0&id=6817c01c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6817c01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6817c01c')) {
      api.createRecord('6817c01c', component.options)
    } else {
      api.reload('6817c01c', component.options)
    }
    module.hot.accept("./userNews.vue?vue&type=template&id=6817c01c&scoped=true", function () {
      api.rerender('6817c01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/breadcrumb/userNews.vue"
export default component.exports